export default function ProbabilityGauge({ label, value = 0, color = "#10B981", testId }) {
  const pct = Math.max(0, Math.min(100, value));
  const deg = pct * 3.6;
  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <div
        className="relative w-28 h-28 rounded-full flex items-center justify-center"
        style={{ background: `conic-gradient(${color} ${deg}deg, var(--gauge-track) 0deg)` }}
      >
        <div className="w-[88px] h-[88px] rounded-full bg-[#0D111A] flex flex-col items-center justify-center">
          <span className="font-mono-num text-2xl font-bold" style={{ color }}>{pct}%</span>
        </div>
      </div>
      <span className="text-xs font-medium uppercase tracking-wider text-slate-400">{label}</span>
    </div>
  );
}
